import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserPlus } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";
import { IoCaretBackCircle, IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { UserAccountFollow } from "../../redux/ApiSlice/AccountProfileSlice";
import { removedFriendshipSuggestion, suggestedMyFriendship } from "../../redux/ApiSlice/RecommendationSlice";
import { IoMdArrowBack } from "react-icons/io";

const FriendshipSuggestion = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, myFriendshipSuggestion, error } = useSelector((state) => state.recommendationUser);

    useEffect(() => {
        dispatch(suggestedMyFriendship());
    }, [dispatch]);

    const handleFollowFun = async (id) => {
        try {
            const response = await dispatch(UserAccountFollow(id));
            if (response.meta.requestStatus === 'fulfilled') {
                // Update the state or perform any other actions after a successful follow
                dispatch(suggestedMyFriendship());
            }
        } catch (error) {
          console.error(error);
        }
    };

    const handleRemoveSuggestion = async (userId) => {
        try {
            const response = await dispatch(removedFriendshipSuggestion(userId));
            if (response.meta.requestStatus === 'fulfilled') {
                dispatch(suggestedMyFriendship());
            }
        } catch (error) {
          console.error(error);
        }
    }

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0">
                <div className="flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="text-[24px] text-black absolute top-1/2 left-2 transform -translate-y-1/2 cursor-pointer"
                    />
                    <p className="text-[16px] font-semibold text-black">
                        Friendship Suggestion
                    </p>
                </div>
            </div>

            {loading &&
                <div className="flex justify-center items-center h-[70vh]">
                    <ClipLoader
                        size={40}
                        color={"#123abc"}
                        loading={loading}
                    />
                </div>
            }

            {error &&
                <div className="flex justify-center items-center h-[70vh]">
                    <p className="text-[10px] text-red-500">Error: {error}</p>
                </div>
            }

            {!loading && !error && (!myFriendshipSuggestion?.results || myFriendshipSuggestion.results.length === 0) && (
                <div className="flex justify-center items-center h-[69vh]">
                    <p className="text-[12px] text-gray-500">
                        No Friendship Suggestion Found.
                    </p>
                </div>
            )}

            {!loading && myFriendshipSuggestion?.results?.map((data) => (
                <div key={data.id} className="flex items-center p-2 border-b border-gray-300/50 dark:border-gray-800/50 w-full">
                    <div className="h-10 w-14 mt-1.5">
                        <img
                            alt={data.name}
                            src={data.suggested_user.avatar_url}
                            onClick={() => navigate(`/account/${data.suggested_user.id}`)}
                            className="h-10 w-10 rounded-full object-cover cursor-pointer border border-gray-300/50 dark:border-gray-800/50 bg-gray-100 dark:bg-[#333333]"
                        />
                    </div>
                    <div className="flex items-center justify-between w-full">
                        <div className="flex flex-col mt-[2px]">
                            <p className="text-[13px] font-semibold line-clamp-1 cursor-pointer text-black dark:text-white">
                                {data.suggested_user.full_name}
                            </p>
                            {/* <div className={`flex items-center gap-x-3 ${data.mutual_friends.length > 0 ? "mt-0" : "mt-0.5"}`}>
                                <p className="text-[10px] text-gray-500">
                                    Followers <span className="font-semibold">{data.suggested_user.followers_count}</span>
                                </p>
                                <p className="text-[10px] text-gray-500">
                                    Following <span className="font-semibold">{data.suggested_user.following_count}</span>
                                </p>
                            </div> */}
                            <div className="flex items-center gap-x-2 mt-1">
                                {data.mutual_friends.length > 0 && (
                                    <>
                                        <div className="flex -space-x-2 overflow-hidden">
                                            {data.mutual_friends.slice(0, 2).map((friends) => (
                                                <img
                                                    key={friends?.id || friends?.avatar_url}
                                                    alt="img"
                                                    src={friends?.avatar_url}
                                                    onClick={() => navigate(`/mutual-friends/${data?.suggested_user?.id}`)}
                                                    className="inline-block h-5 w-5 rounded-full object-cover cursor-pointer bg-black border border-gray-300/50 dark:border-gray-800/50"
                                                />
                                            ))}
                                        </div>
                                        <p className="text-[10px] text-gray-400 cursor-pointer">
                                            {data.mutual_friends.length === 1
                                                ? "1 mutual"
                                                : `${data.mutual_friends.length} mutuals`}
                                        </p>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="flex items-start gap-2">
                            <button
                                onClick={() => handleFollowFun(data.suggested_user.id)}
                                className="flex items-center gap-x-2 bg-[#BDE6FF] text-black px-3 py-1 rounded-full text-[11px] font-semibold"
                            >
                                Follow <FaUserPlus />
                            </button>
                            <button onClick={() => handleRemoveSuggestion(data.suggested_user.id)} className="bg-gray-200 dark:bg-[#333333] text-gray-900 dark:text-gray-100 text-[10px] p-1 rounded-lg">
                                <IoClose className="text-[16px]" />
                            </button>
                        </div>
                    </div>
                </div>
            ))}

        </div>
    )
}

export default FriendshipSuggestion